import React__default from 'react';
import styles from './styles.module.scss.js';
import propsToClass from '../../../helpers/propsToClass.js';
import { COLORS } from '../../../helpers/constants.js';

/**
 * @description Nimvelo ProgressBar component
 * @props timeout, progressPercentage, size, rounded, indeterminate, color, fullWidth, disabled, skeletonText, width, height
 */
const NvProgressBar = ({ progressPercentage, size = 'standard', rounded = false, indeterminate = false, color = COLORS.PRIMARY, fullWidth = false, disabled = false, skeletonText = false, width, height, timeout, }) => (React__default.createElement("div", { className: propsToClass(`${styles.progress_wrapper} ${styles[size]}`, [
        [styles.rounded, rounded],
        [styles.full_width, fullWidth],
        [styles.disabled, disabled],
    ]), style: { width, height } },
    React__default.createElement("div", { className: propsToClass(`${styles.progress_background}`, [
            [styles.rounded, rounded],
        ]), style: { backgroundColor: color } }),
    React__default.createElement("div", { className: propsToClass(`${styles.progress_foreground}`, [
            [styles.rounded, rounded],
            [styles.indeterminate, indeterminate],
            [styles.skeletonText, skeletonText],
            [styles.timeout, !!timeout],
        ]), style: {
            // set progressPercentage as long as indeterminate and skeletonText aren't set
            width: indeterminate || skeletonText ? undefined : `${progressPercentage}%`,
            backgroundColor: color,
            animationDuration: indeterminate || skeletonText || progressPercentage
                ? undefined
                : `${timeout}ms`,
        } })));

export { NvProgressBar, NvProgressBar as default };
//# sourceMappingURL=component.js.map
